// 计划单接口
const cache = {}
// 分页列表
export function getScheduleList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/schedule/pageList',
    data
  })
}
// 查询单条记录并返回操作日志
export function getScheduleById(params) {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/schedule/dataOne',
    params
  })
}
// 复制
export function copySchedule(params) {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/schedule/copy',
    params
  })
}
// 更新计划单状态
export function operate(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/schedule/operate',
    data
  })
}
// 更新计划单状态，不显示右上角提示信息(列表开关)
export function operateSchedule(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/schedule/operate',
    data
  }).then(data => {
    return data
  }).catch(e => {
    return {
      isError: true,
      errorMsg: e.message
    }
  })
}
// 计划单下的素材
export function scheduleMedias(id) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/media/scheduleMedias?scheduleId=' + id
  })
}
// 订单下的计划单
export function getScheduleByOrderId(params) {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/schedule/getScheduleByOrderId',
    params
  })
}
//* *** 广告基础条件公共接口 ****//

// 获取设备信息
export function getDevice() {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/base/getDevice'
  })
}
// 获取监测商信息
export function getProviderList() {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/base/getProviderList'
  })
}

// 获取地区信息
export function getRegions() {
  if (!cache.region) {
    return this.fetch({
      method: 'get',
      url: 'api/dsp/base/getRegions'
    }).then((data) => {
      cache.region = data
      return Promise.resolve(data)
    })
  } else {
    return Promise.resolve(cache.region)
  }
}
// 获取广告位（没有价格策略）
export function getSpace() {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/base/getSpace'
  })
}
// 获取广告位（带有价格策略)
export function getScheduleSpace(params) {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/base/getScheduleSpace',
    params
  })
}
// 获取一口价下地域
export function getAreaPrice(params) {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/order/getAreaPrice',
    params
  })
}
// 业务员
export function getSalesmanList(params) {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/order/getSalesmanList',
    params
  })
}
// 获取登录下广告主信息
export function getAvailableCustomer() {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/adDspPartner/getAvailableCustomer'
  })
}

// 获取登录用户接口
export function getAccount(params) {
  return this.fetch({
    method: 'get',
    url: 'api/getUserInfo',
    params
  })
}
// 计划单排期
export function getScheduling(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/base/schedulingPageList',
    data
  })
}
// 获取计划单定向条件
export function getScheduleDirect(params) {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/schedule/getScheduleDirect',
    params
  })
}
// 获取mac
export function getMacPageList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/base/macPageList',
    data
  })
}
// 获取媒资标签
export function getMediaTags() {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/base/getMediaTags'
  })
}
// 保存新计划
export function SaveNewSchedule(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/schedule/add',
    data
  })
}

// 编辑计划单 ，有草稿，待审核，待投放可以更新计划单
export function editSchedule(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/schedule/edit',
    data
  })
}
// 获取计划单基础数据字典
export function getBaseDict() {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/schedule/getBaseDict'
  })
}
// 计划单详情
export function getScheduleDetail(params) {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/schedule/detail',
    params
  })
}

// 批量建单
export function saveBatchSchedule(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/scheduleBatch/save',
    data
  })
}
// 批量建单
export function addScheduleUvRate(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/scheduleBatch/addScheduleUvRate',
    data
  })
}

// 保存批量建单扩展参数
export function saveBatchExtendParam(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/scheduleBatch/addScheduleExtendParams',
    data
  })
}

// 重新计算分天投的每日投放量
export function getScheduleRegionDaily(params) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/schedule/getScheduleRegionDaily',
    params
  })
}
// 查询关联
export function getUnionPageList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/schedule/unionPageList',
    data
  })
}
// 查询已关联计划单列表
export function getUnionScheduleList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/schedule/getUnionScheduleList',
    data
  })
}
// 获取本次计划单可使用的广告位
export function getScheduleNeedAdSpace(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/schedule/getScheduleNeedAdSpace',
    data
  })
}

// 批量建单-获取所有的媒体方
export function getCableChannel(params) {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/schedule/getCableChannelList',
    params
  })
}

// 定价策略和一口价的情况下获取售卖价格
export function getSellingPrice(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/schedule/getSellingPrice',
    data
  })
}

// 获取dmp策略
export function getDmpPolicyList(params) {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/dmpPolicyCrowd/getDmpPolicyCrowd',
    params
  })
}

// 根据策略id获取人群标签
export function getCrowdList(params) {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/dmpPolicyCrowd/getDmpPolicyPeople',
    params
  })
}

// 查询爱奇艺媒体方是否可选
export function getCabelStatus(params) {
  return this.fetch({
    method: 'get',
    url: 'api/admin/adCableChannel/getCableStatus',
    params
  })
}

// 获取三方DMP接口
export function getThirdDmpList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/admin/adThridDmp/dataList',
    data
  })
}

// 获取Dmp人群包
export function getDmpCrowds(params) {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/dmpCrowd/getDmpCrowds',
    params
  })
}

// 获取业财合规化开关
export function getErpModeSwitch() {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/schedule/getErpModeSwitch'
  })
}

// 获取业财合规化开关
export function getSalesSubOrders(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/salesAdvertising/salesSuborder?id=' + data.id
  })
}

// 获取影视查询条件
export function getVideoConditions() {
  return this.fetch({
    method: 'get',
    url: 'api/dsp/videoStock/getBaseInfo'
  })
}

// 查询影视top
export function getVideoTopList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/videoStock/videoStockList',
    data
  })
}

// 查询定向包分页
export function getDirectPackagePageList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/adDirectPackage/pageList',
    data
  })
}

// 获取定向包
export function getDirectPackages(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/adDirectPackage/dataList',
    data
  })
}

// 获取定向包详情
export function getDirectPackageDetail(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/adDirectPackage/dataOne',
    data
  })
}

// 删除定向包
export function delDirectPackage(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/adDirectPackage/remove',
    data
  })
}

// 获取品牌机型
export function getBrandList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/schedule/getScheduleNeedBrand',
    data
  })
}

// 校验定向包名称
export function checkDirectPackageName(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/adDirectPackage/checkData',
    data
  })
}

// nlp查询地址
export function getNlpRegion(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/api/nlp/getNlpRegion',
    data
  })
}

// 查询推荐流List
export function getRecStreamList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/recStream/dataList',
    data
  })
}

// 根据计划ID查询推荐流
export function getRecStreamInfo(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/recStream/data',
    data
  })
}
